export type StreakDay = {
  date: string;
  label: string;
  completed: boolean;
};

export type LearningStreak = {
  currentStreak: number;
  longestStreak: number;
  todayCompleted: boolean;
  lastActivityDate: string | null;
  recentDays: StreakDay[];
};

export const EMPTY_STREAK: LearningStreak = {
  currentStreak: 0,
  longestStreak: 0,
  todayCompleted: false,
  lastActivityDate: null,
  recentDays: [],
};
